import { VersionItem } from "models/api/versions"
import DataTimeText from "components/Common/DataTime"
import { VersionStatus } from "models/api/status"
import { MdEdit, MdDelete, MdRestore, MdDeleteForever } from "react-icons/md"

type ColumnHandler = (row: VersionItem) => void;

export const generateColumns = (
    handleEditModalOpening: ColumnHandler,
    handleDeleteRow: ColumnHandler,
    handleRestoreVersion: ColumnHandler,
    handleHardDeleteVersion: ColumnHandler,
) => ([
  { key: 'name', name: 'Версия' },
  { key: 'platform', name: 'Платформа' },
  { key: 'description', name: 'Примечание' },
  { key: 'status', name: 'Статус' },
  {
      key: 'creationDate',
      name: 'Создан',
      formatter: ({ row }: { row: VersionItem }) => (
          <>
              <div>
                  <DataTimeText value={row.creationDate} />
              </div>
          </>
      ),
  },
  {
      key: 'maintenanceEnd',
      name: 'Дата обновления',
      formatter: ({ row }: { row: VersionItem }) => (
          <>
              <div>
                  <DataTimeText value={row.lastUpdate} />
              </div>
          </>
      ),
  },
  {
      key: 'actions',
      name: 'Действия',
      cellClass: 'base-data-grid__cell_centered no-change-modal',
      headerCellClass: 'base-data-grid__cell_centered',
      width: 100,
      minWidth: 100,
      draggable: false,
      resizable: false,
      clickDisable: true,
      formatter: ({ row }: { row: VersionItem }) => {
          return (
              <>
                  {row.isActive ? (
                      <>
                          <MdEdit
                              size={20}
                              className={`cursor--pointer actions-icon ${row.status === VersionStatus.Deprecated ? 'disabled' : ''}`}
                              onClick={() => handleEditModalOpening(row)}
                              title="Редактировать версию"
                          />
                          <MdDelete
                              size={20}
                              className="cursor--pointer actions-icon"
                              onClick={() => handleDeleteRow(row)}
                              title="Удалить версию"
                          />
                      </>
                  ) : (
                      <>
                          <MdRestore
                              size={20}
                              className="cursor--pointer actions-icon"
                              onClick={() => handleRestoreVersion(row)}
                              title="Восстановить версию"
                          />
                          <MdDeleteForever
                              size={20}
                              className="cursor--pointer actions-icon text-danger"
                              onClick={() => handleHardDeleteVersion(row)}
                              title="Удалить навсегда"
                          />
                      </>
                  )}
              </>
          );
      },
  },
]);